// extracted by mini-css-extract-plugin
export var icon = "MenuButton-module--icon--BgjFr";
export var label = "MenuButton-module--label--GrJz2";
export var line = "MenuButton-module--line--LW3xV";
export var menuOpen = "MenuButton-module--menuOpen--rFsOO";
export var menuWrap = "MenuButton-module--menuWrap--LdjU-";